import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const AircraftStatementRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--aircraft-statement']}>
    <Route index element={<Index />} />
  </SubRouter>
))
